import { render, staticRenderFns } from "./careerResultNopay.vue?vue&type=template&id=a7b80ef2&scoped=true"
import script from "./careerResultNopay.vue?vue&type=script&lang=js"
export * from "./careerResultNopay.vue?vue&type=script&lang=js"
import style0 from "./careerResultNopay.vue?vue&type=style&index=0&id=a7b80ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b80ef2",
  null
  
)

export default component.exports